export const addToQueue = (item) => ({
    type: 'ADD_TO_QUEUE',
    item: item
});

export const removeFromQueue = (item) => ({
    type: 'REMOVE_FROM_QUEUE',
    item: item
});
